<template>
  <div class="mod">
    <!-- 规则弹窗 -->
    <div class="mod_box">
      <div class="h2">规则</div>
      <div class="text">
        1、关于游戏：宝藏之旅途径三个景点，钟楼、华山、大雁塔。分别代表爱情卡、事业卡和健康卡，根据开启时间到达相应景点寻找宝藏。
      </div>
      <div class="text">
       2、关于抽奖机会：做任务获得抽奖机会，即三个景点中宝箱开启次数。机会获取方式：每天打开怡康到家APP/小程序获得1次机会、每天分享邀请好友参与游戏获得1次机会，上限3次。每天下单获得3次机会，无上限。
      </div>
      <div class="text">
      3、关于时间：11月1-3日解锁钟楼景点、11月4-6日解锁华山景点、11月7-10日解锁大雁塔景点，11月11日合成三张卡片，11月11晚8点终极大奖开奖。
      </div>
      <div class="text">
      4、关于奖品：每个景点6个宝箱，分别开出卡片X1，商品券X4及一个空箱，具体商品券见关卡页。合成三张卡片参与终极大奖开奖。
      </div>
      <div class="text">终极大奖：</div>
      <div class="text">一等奖:1000元现金</div>
      <div class="text">二等奖:黄金转运珠</div>
      <div class="text">三等奖:养生堂护手霜</div>
      <div class="text">四等奖:薇诺娜面膜礼盒</div>
      <div class="text">五等奖:怡康到家50元优惠券（满100元可用）</div>
      <div class="text">六等奖:怡康到家10元优惠券（满19元可用）</div>
      <div class="btn" @click="ok()">知道了</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Rule",
  data() {
    return {};
  },
  props: {
    type: Boolean,
  },
  methods: {
    ok() {
      this.$emit("transfer");
    },
  },
};
</script>

<style scoped lang="scss">
/* mod */
.mod {
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.431);
  z-index: 90;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mod_box {
  width: 84%;
  height: 70%;
  background: #fff;
  font-size: 14px;
  padding: 10px 20px;
  box-sizing: border-box;
  border-radius: 20px;
  overflow: auto;
  text-align: left;
}
.text {
  margin-top: 14px;
  color: #363636;
}
.h2 {
  font-size: 20px;
  font-weight: 600;
  color: #7e33ff;
  text-align: center;
  margin-top: 10px;
}
.btn {
  width: 180px;
  height: 40px;
  line-height: 40px;
  background: #7e33ff;
  color: #fff;
  border-radius: 20px;
  text-align: center;
  margin: 0 auto;
  margin-top: 20px;
}
</style>
